"use client";

type Props = {
	label: string;
};

/**
 * Triggers the browser print dialog — the checklist's "download" mechanism.
 * A print stylesheet (see the inline `<style>` in `page.tsx`) hides site
 * chrome so `window.print()` produces a clean, single-column checklist with
 * no PDF-generation pipeline required.
 */
export function PrintButton({ label }: Props) {
	return (
		<button
			type="button"
			onClick={() => window.print()}
			className="no-print inline-flex items-center gap-2 rounded-full border border-border bg-card px-5 py-2.5 text-sm font-semibold text-foreground transition-colors hover:border-primary/50 hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background"
		>
			<svg
				viewBox="0 0 24 24"
				className="h-4 w-4 fill-none stroke-current"
				strokeWidth={2}
				aria-hidden="true"
				focusable="false"
			>
				<path
					strokeLinecap="round"
					strokeLinejoin="round"
					d="M6 9V3h12v6M6 18H4a1 1 0 01-1-1v-6a1 1 0 011-1h16a1 1 0 011 1v6a1 1 0 01-1 1h-2M6 14h12v7H6v-7z"
				/>
			</svg>
			{label}
		</button>
	);
}
